import { TalentListPage } from "@/features/talent/pages/TalentList";

const TalentList = () => {
  return <TalentListPage />;
};

export default TalentList;
